import { AzureMP } from "react-azure-mp"
export default function Video(props) {
    const videoDownloadUrl = props.videoDownloadUrl

    return (
        <AzureMP
            skin="amp-flush"
            options={{ autoplay: true }}
            src={[{ src: videoDownloadUrl, type: "video/mp4" }]}
        />
    )

}